// extracted by mini-css-extract-plugin
module.exports = {"iframeContainer":"parse-view_iframeContainer__wdZAR"};